import vue from "../main";
import moment from "moment";
export const requiredValidator = v => !!v || vue.$t("global.error.required");
export const dateLaterThanNow = v => moment(v).isAfter(moment()) || vue.$t("global.error.dateLaterThanNow");
